export namespace PlatformConstants {

  export enum Versions {
    VERSION_1 = 'v1',
  }

  export enum PlatformTypes {
    IOS = "ios",
    ANDROID = "android",
    MOBILE = "mobile",
    MOBILEWEB = "mobileweb",
    IPHONE = "iphone",
    PWA = "pwa",
    PHABLET = "phablet",
    IPAD = "ipad",
    TABLET = "tablet",
    DESKTOP = "desktop",
    ELECTRON = "electron",
    CAPACITOR = "capacitor",
    CORDOVA = "cordova",
    HYBRID = "hybrid",
  }

}